import React, { useContext, useEffect, useMemo, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Container,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell,
  TablePagination,
  TableRow,
  tableCellClasses,
  Paper,
  TextField,
  Typography,
  Chip
} from '@mui/material';
import moment from 'moment';
import { saveAs } from 'file-saver';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axios from '../../utils/axios';
import UIContext from '../../context/UIContext';
import NoResultsFound from '../../components/NoResultsFound';

const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  minWidth: '150px',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#4379F2',
  },
  whiteSpace: 'nowrap',
});

const statusOptions = [
  { label: 'All', value: '0' },
  { label: 'Hot', value: 'H' },
  { label: 'Cold', value: 'C' },
  { label: 'Warm', value: 'W' },
];


const searchByOptions = [
  { label: 'Phone Number', value: 'phonenumber' },
  { label: 'Ledger', value: 'ledger' },
];

const LedgerFollowupTracker = () => {

  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const [expanded, setExpanded] = useState(true);
  const [branchList, setBranchList] = useState([]);
  const [ledgerPhoneFilterData, setLedgerPhoneFilterData] = useState([]);
  const [getDataForView, setGetDataForView] = useState([]);
  const [salesExecutiveFilterData, setSalesExecutiveFilterData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterInputs, setFilterInputs] = useState({

    fromDate: moment().startOf('month').format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    Branch: '0',
    status: '0',
    ledger: '',
    salesExecutive: '',
    searchBy: 'phonenumber',
  });
  const [formErrors, setFormErrors] = useState({
    fromDate: '',
    toDate: '',
  });

  const getAllData = async () => {

    if (!validateFilters()) {
      return; // If validation fails, stop the request
    }
    try {
      showLoading();
      if (sessionStorage.getItem('userRole') === 'Admin') {
        const response = await axios.post(
          "/Reports/AdminLedgerFollowupTracker",
          {
            fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
            toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
            BranchId: filterInputs.BranchId?.BranchId || 0,
            LeadStatus: filterInputs.status,
            ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
            salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
            createdBy: filterInputs.createdBy?.salesPersonId || 0,
          }
        );
        setGetDataForView(response.data);
      }
      else {
        const response = await axios.post(
          "/Reports/SalesLedgerFollowupTracker",
          {
            fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
            toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
            BranchId: filterInputs.BranchId?.BranchId || 0,
            LeadStatus: filterInputs.status,
            ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
            createdBy: filterInputs.createdBy?.salesPersonId || 0,
            salesExecutiveId: sessionStorage.getItem("UserId"),
          }
        );
        setGetDataForView(response.data);
      }
    }
    catch (e) {
      openSnackBar(e.response?.data || 'Something went wrong! Try again.', 'error');
    }
    hideLoading();
  }

  const GetLedgerFollowupTrackerExcel = async () => {


    if (!validateFilters()) {
      return; // If validation fails, stop the request
    }
    try {
      showLoading();
      if (sessionStorage.getItem('userRole') === 'Admin') {
        const response = await axios.post(
          "/Reports/GetLedgerFollowupTrackerExcel",
          {
            fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
            toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
            BranchId: filterInputs.BranchId?.BranchId || 0,
            LeadStatus: filterInputs.status,
            ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
            salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
            createdBy: filterInputs.createdBy?.salesPersonId || 0,
            searchby: filterInputs.searchBy,
            ledger: filterInputs.ledger?.CUSTOMERNAME || '',
            phonenumber: filterInputs.ledger?.Phone || '',
            Branch: filterInputs.BranchId?.BranchName || '',
            salesExecutiveName: filterInputs.salesExecutive?.salesPersonName || "",
            createdByName: filterInputs.createdBy?.salesPersonName || "",
            UserId: sessionStorage.getItem("UserId")
          },
          { responseType: 'blob' }
        );
        const excelBlob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        });
        saveAs(excelBlob, `Admin Ledger Followup Tracker-${moment(new Date()).format('MMMM Do YYYY, h-mm a')}`);
        setTimeout(() => {
          hideLoading();
        }, 2000);
      }

      else {
        const response = await axios.post(
          "/Reports/GetSalesLedgerFollowupTrackerExcel",
          {
            fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
            toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
            BranchId: filterInputs.BranchId?.BranchId || 0,
            LeadStatus: filterInputs.status,
            ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
            // salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
            createdBy: filterInputs.createdBy?.salesPersonId || 0,
            searchby: filterInputs.searchBy,
            ledger: filterInputs.ledger?.CUSTOMERNAME || '',
            phonenumber: filterInputs.ledger?.Phone || '',
            Branch: filterInputs.BranchId?.BranchName || '',
            // salesExecutiveName: filterInputs.salesExecutive?.salesPersonName || "",
            createdByName: filterInputs.createdBy?.salesPersonName || "",
            salesExecutiveId: sessionStorage.getItem("UserId"),
          },
          { responseType: 'blob' }
        );
        const excelBlob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        });
        saveAs(excelBlob, `Sales Ledger Followup Tracker-${moment(new Date()).format('MMMM Do YYYY, h-mm a')}`);
        setTimeout(() => {
          hideLoading();
        }, 2000);
      }
    }
    catch (error) {
      if (error.response?.status === 404) {
        openSnackBar('No records found to export.', 'error');
      } else {
        openSnackBar('Something went wrong! Try again.', 'error');
      }
    }
    hideLoading();
  }

  const validateFilters = () => {
    const errors = {};
    // Validate fromDate: should not be empty
    if (!filterInputs.fromDate) {
      errors.fromDate = 'From date is required';
    } else if (!moment(filterInputs.fromDate, 'YYYY-MM-DD', true).isValid()) {
      errors.fromDate = 'Invalid date format';
    }

    // Validate toDate: should not be empty and be a valid date
    if (!filterInputs.toDate) {
      errors.toDate = 'To date is required';
    } else if (!moment(filterInputs.toDate, 'YYYY-MM-DD', true).isValid()) {
      errors.toDate = 'Invalid date format';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const handleFilterInputs = (e) => {
    setFilterInputs({
      ...filterInputs,
      [e.target.name]: e.target.value,
    });
  };

  const GetAllHelpData = async () => {
    try {
      showLoading();
      const userID = sessionStorage.getItem('UserId');
      const userRole = sessionStorage.getItem('userRole');
      const companyId = 4;

      let customerHelpUrl = '';
      let salesExcutiveUrl = '';

      if (userRole === 'Admin') {
        customerHelpUrl = '/master/customer/GetCustomerHelp/4';
        salesExcutiveUrl = '/Approval/LoginApprovalRoute/GetAllSalesExecutive';
      } else {
        customerHelpUrl = `/Transactions/SalesControls/GetCustomerHelpForSE/${companyId}/${userID}/0`;
        salesExcutiveUrl = `/Approval/LoginApprovalRoute/GetAllAssignedSalesExecutive/${sessionStorage.getItem('UserId')}`;
      }

      const [ledgerResponse, salesExecutiveResponse] = await Promise.all([
        axios.get(customerHelpUrl),
        axios.get(salesExcutiveUrl)
      ]);

      setLedgerPhoneFilterData(ledgerResponse.data);
      setSalesExecutiveFilterData(salesExecutiveResponse.data);
    } catch (e) {
      openSnackBar('Something Went Wrong', 'error');
    }
    hideLoading();
  };

  async function GetBranchList(cntry) {
    try {
      const requestData = {
        CompanyId: sessionStorage.getItem('CompanyId'),
      };

      const config = {
        headers: {
          Country: cntry,
        },
      };
      showLoading();
      let response
      if (sessionStorage.getItem('userRole') === 'Admin') {
        response = await axios.post('signup/GetBranchList', requestData, config);
      } else {
        response = await axios.post('Approval/LoginApprovalRoute/GetBranchLog', {
          UserId: sessionStorage.getItem('UserId')
        }, config);
      }
      const data = response.data.filter((i) => i.webBranch === 'Y');
      setBranchList(data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();

  }

  useEffect(() => {
    getAllData()
    GetAllHelpData();
    GetBranchList(sessionStorage.getItem('Origin'));
  }, []);

  // pagination
  const { totalRows, currentPage } = useMemo(() => {
    const totalRows = getDataForView.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { totalRows, currentPage };
  }, [getDataForView, page, rowsPerPage]);


  return (
    <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
      <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
        <Typography
          variant="h5"
          p={1}
          boxShadow={1}
          borderColor="#11235A"
          textAlign={'center'}
          borderRadius={2}
          pl={2}
          color="white"
          sx={{
            // borderRadius: 50,
            background: '#8EACCD',
            boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
          }}
        >
          <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
            Ledger Followup Tracker
          </Typography>
        </Typography>
      </Grid>
      <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
        <Accordion
          expanded={expanded}
          onChange={() => {
            setExpanded((expand) => !expand);
          }}
          disableGutters
          sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: '#8EACCD' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ borderTop: 'none' }}
          >
            <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
              <IconButton aria-label="ExpandMoreIcon" color="#8EACCD">
                <FilterAltIcon style={{ color: '#8EACCD', width: 24, height: 24 }} />
              </IconButton>
              <Typography
                sx={{
                  color: '#8EACCD',
                  '&.active': {
                    color: 'text.primary',
                    bgcolor: 'action.selected',
                    fontWeight: 'fontWeightBold',
                  },
                }}
                variant="h6"
              >
                Filters
              </Typography>
            </Stack>
          </AccordionSummary>

          <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
            <Grid container spacing={2} p={1} pt={0} mb={0.5} rowSpacing={2} columnSpacing={1}>

              <Grid item md={3} xs={12}>
                {/* From Date */}
                <TextField
                  fullWidth
                  label="From Date"
                  type="date"
                  name="fromDate"
                  value={filterInputs.fromDate}
                  onChange={handleFilterInputs}
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  size="small"
                  error={!!formErrors.fromDate}
                  helperText={formErrors.fromDate}
                  inputProps={{ max: '9999-12-31' }}
                />
              </Grid>
              <Grid item md={3} xs={12}>
                {/* To Date */}
                <TextField
                  fullWidth
                  label="To Date"
                  type="date"
                  name="toDate"
                  value={filterInputs.toDate}
                  onChange={handleFilterInputs}
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  size="small"
                  error={!!formErrors.toDate}
                  helperText={formErrors.toDate}
                  inputProps={{ max: '9999-12-31' }}
                />
              </Grid>
              <Grid item md={3} xs={12}>
                {/* Branch */}
                <Autocomplete
                  options={branchList} // Use branchList as options
                  getOptionLabel={(branch) => branch.BranchName} // Display branch names
                  renderOption={(props, branch) => (
                    <li {...props} key={branch.BranchId}>
                      {branch.BranchName}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => option.BranchId === value?.BranchId}
                  value={filterInputs.BranchId || null} // Select branch from filterInputs
                  name="BranchId"
                  onChange={(event, value) => {
                    setFilterInputs({ ...filterInputs, BranchId: value });
                  }}
                  size="small"
                  renderInput={(params) => <TextField {...params} label="Branch" variant="outlined" />}
                />

              </Grid>

              <Grid item md={3} xs={12}>
                {/* Status Filter */}
                <TextField
                  fullWidth
                  select
                  label="Status"
                  name="status"
                  value={filterInputs.status}
                  onChange={handleFilterInputs}
                  variant="outlined"
                  size="small"
                >
                  {statusOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item md={2} xs={12}>
                {/* Search by Filter */}
                <TextField
                  fullWidth
                  select
                  label="Search by"
                  name="searchBy"
                  value={filterInputs.searchBy}
                  onChange={(e) => {
                    setFilterInputs({
                      ...filterInputs,
                      ledger: '',
                      searchBy: e.target.value,
                    });
                  }}
                  variant="outlined"
                  size="small"
                >
                  {searchByOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item md={sessionStorage.getItem('userRole') === 'Admin' ? 3 : 5} xs={12}>
                <Autocomplete
                  key={filterInputs.searchBy}
                  options={ledgerPhoneFilterData}
                  getOptionLabel={(customer) =>
                    filterInputs.searchBy === 'phonenumber' ? customer.Phone : customer.CUSTOMERNAME
                  }
                  renderOption={(props, customer) => (
                    <li {...props} key={customer.CUSTOMERID}>
                      {filterInputs.searchBy === 'phonenumber' ? customer.Phone : customer.CUSTOMERNAME}
                    </li>
                  )}
                  isOptionEqualToValue={(customer) => customer.CUSTOMERID === filterInputs.ledger.CUSTOMERID}
                  value={filterInputs.ledger || null}
                  name="ledger"
                  onChange={(event, value) => {
                    setFilterInputs({
                      ...filterInputs,
                      ledger: value,
                    });
                  }}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={filterInputs.searchBy === 'phonenumber' ? 'Phone Number' : 'Ledger'}
                    />
                  )}
                />
              </Grid>
              {sessionStorage.getItem('userRole') === 'Admin' &&
                <Grid item md={3} xs={12}>
                  <Autocomplete
                    options={salesExecutiveFilterData}
                    getOptionLabel={(salesPerson) => salesPerson.salesPersonName}
                    renderOption={(props, salesPerson) => (
                      <li {...props} key={salesPerson.salesPersonId}>
                        {salesPerson.salesPersonName}
                      </li>
                    )}
                    isOptionEqualToValue={(salesPerson) =>
                      salesPerson.salesPersonId === filterInputs.salesExecutive.salesPersonId
                    }
                    value={filterInputs.salesExecutive || null}
                    name="salesExecutive"
                    onChange={(event, value) => {
                      setFilterInputs({ ...filterInputs, salesExecutive: value });
                    }}
                    size="small"
                    renderInput={(params) => <TextField {...params} label="Sales Executive" />}
                  />
                </Grid>
              }

              <Grid item md={sessionStorage.getItem('userRole') === 'Admin' ? 2 : 3} xs={12}>
                <Autocomplete
                  options={salesExecutiveFilterData}
                  getOptionLabel={(salesPerson) => salesPerson.salesPersonName}
                  renderOption={(props, salesPerson) => (
                    <li {...props} key={salesPerson.salesPersonId}>
                      {salesPerson.salesPersonName}
                    </li>
                  )}
                  isOptionEqualToValue={(salesPerson) =>
                    salesPerson.salesPersonId === filterInputs.salesExecutive.salesPersonId
                  }
                  value={filterInputs.createdBy || null}
                  name="createdBy"
                  onChange={(event, value) => {
                    setFilterInputs({ ...filterInputs, createdBy: value });
                  }}
                  size="small"
                  renderInput={(params) => <TextField {...params} label="Created By" />}
                />
              </Grid>


              <Grid item xs={1} sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                {/* View Button */}
                <Button variant="contained" color="primary" onClick={getAllData} fullWidth sx={{ boxShadow: 0 }}>
                  View
                </Button>
              </Grid>

              <Grid item xs={1} sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                <Button
                  variant="contained"
                  style={{ color: 'white', backgroundColor: '#118a27' }}
                  onClick={GetLedgerFollowupTrackerExcel}
                  fullWidth
                >
                  Excel
                </Button>
              </Grid>
            </Grid>
            {getDataForView.length > 0 ? (
              <>
                <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit', maxHeight: 600 }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="center">S.No</StyledTableCell>
                        <StyledTableCell align="left" >Ledger</StyledTableCell>
                        <StyledTableCell align="center">Followup Date&Time</StyledTableCell>
                        <StyledTableCell align="center">Remarks</StyledTableCell>
                        <StyledTableCell align="center">Status</StyledTableCell>
                        <StyledTableCell align="center">Branch</StyledTableCell>
                        <StyledTableCell align="center">Sales Executive</StyledTableCell>
                        <StyledTableCell align="center">Created Date&Time</StyledTableCell>
                        <StyledTableCell align="center">Created By</StyledTableCell>

                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(rowsPerPage > 0
                        ? getDataForView.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : getDataForView
                      ).map((data, i) => (
                        <TableRow key={data.CUSTOMERID} hover>
                          <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                          <TableCell align="left" >{data.CustomerName}</TableCell>
                          <TableCell align="center">{moment.utc(data.followupDate).format('LLL')}</TableCell>
                          <TableCell align="center">{data.remarks}</TableCell>
                          <TableCell align="center">
                            {data.LeadStatus === 'Hot' ? (
                              <Chip size="small" color="error" label="Hot 🔥" />
                            ) : data.LeadStatus === 'Warm' ? (
                              <Chip label="Warm ☀️" size="small" color="warning" />
                            ) : data.LeadStatus === 'Cold' ? (
                              <Chip label="Cold ❄️" size="small" color="info" />
                            ) : (
                              ''
                            )}</TableCell>
                          <TableCell align="center">{data.Branch_Name}</TableCell>
                          <TableCell align="center">{data.SalesPersonName}</TableCell>
                          <TableCell align="center"> {data.createdOn ? moment(data.createdOn).local().format('DD-MM-YYYY hh:mm:ss A') : '-'}</TableCell>
                          <TableCell align="center">{data.CreatedUser}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>

                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={totalRows}
                  rowsPerPage={rowsPerPage}
                  page={currentPage}
                  onPageChange={(event, newPage) => setPage(newPage)}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(0);
                  }}
                  mt={2}
                />
              </>

            ) : (
              <NoResultsFound />
            )}

          </AccordionDetails>
        </Accordion>
      </Stack>
    </Container>
  )
}

export default LedgerFollowupTracker